<app-page-header title="Home" active_item="WebHook" titleLink="/reports"></app-page-header>
<div class="loading-webhook" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<form [formGroup]="webhook">
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.deposit' | translate}}</div>
      </div>
      <div class="card-body">
          <div class="row">
            <div class="col-xl-6 col-lg-12 col-sm-12">
              <div class="form-group">
                <label for="txtUrlDeposito" class="form-label">{{ 'common.url' | translate}}: </label>
                <input [formControl]="webhook.controls.urlDeposito" class="form-control" type="text" name="urlDeposito" id="txtUrlDeposito">
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.withdraw' | translate}}</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="form-group">
              <label for="txtUrlSaque" class="form-label">{{ 'common.url' | translate}}: </label>
              <input [formControl]="webhook.controls.urlSaque" class="form-control" type="text" name="urlSaque" id="txtUrlSaque">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-xl col-lg-6 col-sm-6">
  <button type="button" class="our-button btn btn-pill btn-primary float-end" (click)="changeWebHook()"><i class="fe fe-plus"></i>{{ 'common.save' | translate}}</button>
</div>
</form>
